import { Navigate, Route, Routes } from 'react-router-dom'
import { Data } from '../pages/data'
import { ReportPropgramationData } from '../pages/programation'
import { ReportPropgramatioProgressQuestionnaire } from '../pages/progressQuestionnaire'

const ReportsRoutes = () => {
  return (
    <Routes>
      {/* DASHBOARD */}
      <Route index element={<Navigate to="/programmed" />} />
      <Route path="programmed" element={<Data />} />
      <Route path="programation" element={<ReportPropgramationData />} />
      <Route path="progress-questionnaire" element={<ReportPropgramatioProgressQuestionnaire />} />
    </Routes>
  )
}

export default ReportsRoutes
